import React from 'react';
import { Link } from 'react-router-dom';
import button from '../img/button.png';

function Hero({ img }) {
  return (
    <section className="pb-hero" style={{ backgroundImage: `url(${img})` }}>
      <div className="pb-hero-veil" />

      <p className="pb-hero-side">Independent digital studio / Product design and development</p>

      <div className="pb-hero-copy">
        <h1 className="pb-hero-title">
          Product Design<br />Development<br />Art
        </h1>
        <p className="pb-hero-lede">
          Pixelbear.Studio was born from a love of design and aesthetics. I love making things look good, provocative, inspiring.
        </p>
        <Link to="/works" className="pb-button" style={{ backgroundImage: `url(${button})` }}>
          Portfolio
        </Link>
      </div>

      <div className="pb-wordmark-band">
        <p className="pb-wordmark">PIXEL.BEAR</p>
        <p className="pb-scroll-cue">Scroll to explore ↓</p>
      </div>
    </section>
  );
}

export default Hero;
